import { isEmpty, omit } from 'ramda'
import { useFilter, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import FastFilters from './filters/FastFilters'
import FiltersBar from './filters/FiltersBar'
import IconButton from '../../../components/actions/IconButton'
import ScreenDropdown from '../../../containers/screens/ScreenDropdown'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ControlBar = ({ hideFastFilters, selectedScreen, children, rightContent, middleContent, hideDateFilters }) => {
  const { t } = useTranslation()

  const { fixedFilterFields } = useFilterState()
  const filter = omit(fixedFilterFields, useFilter())
  const hasFilter = !isEmpty(filter)

  const [isFiltering, setFiltering] = useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const searchOptions = [
    { label: t('listServiceOrders:search.normal'), value: '', icon: 'BsSearch' },
    { label: t('listServiceOrders:search.reply'), value: 'REPLY_VALUE', icon: 'BsCardHeading' },
    { label: t('listServiceOrders:search.field'), value: 'FIELD_VALUE', icon: 'RiListSettingsLine' },
    { label: t('listServiceOrders:search.place'), value: 'PLACE', icon: 'RiBuildingLine' }
  ]

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.3}>
        <Grid flex={1} gutter={0.3}>
          <Col>
            <ScreenDropdown selected={selectedScreen} screen="service_orders" />
          </Col>

          <Col>
            <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />
          </Col>

          <Col>{children}</Col>
        </Grid>

        <Col flex={3} align="center">
          {!hideFastFilters && (middleContent || <FastFilters />)}
        </Col>

        <Col flex={1}>{rightContent || <SearchInput options={searchOptions} />}</Col>
      </Grid>
      <Separator weight={6} />

      <FiltersBar open={isFiltering} onClose={hideFilter} hideDateFilters={hideDateFilters} />
    </>
  )
}

export default ControlBar
